import script from "./PaymentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentDialog.vue?vue&type=script&setup=true&lang=js"

import "./PaymentDialog.vue?vue&type=style&index=0&id=22575401&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22575401"]])

export default __exports__